import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../contexts/AuthContext';
import { userService } from '../../../api/services';
import { translateApiError } from '../../../utils/apiError';

export default function NaverCallback() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { socialLogin } = useAuth();

  useEffect(() => {
    const run = async () => {
      try {
        const hash = window.location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const accessToken = params.get('access_token');

        if (!accessToken) throw new Error('access_token not found');

        await socialLogin('naver', accessToken);

        // OAuth 응답에 email/phone/name 누락이면 보충 입력 페이지로
        let needsCompletion = false;
        try {
          const profile = await userService.getProfile();
          needsCompletion = !profile?.email?.trim() || !profile?.phone?.trim() || !profile?.name?.trim();
        } catch { /* getProfile 실패 시 통과 */ }

        if (needsCompletion) {
          navigate('/auth/complete-profile', { replace: true });
          return;
        }
        const redirectTo = sessionStorage.getItem('loginRedirect') || '/';
        sessionStorage.removeItem('loginRedirect');
        navigate(redirectTo, { replace: true });
      } catch (err) {
        // 폰번호 중복 케이스: 이미 다른 provider 로 가입된 사용자 — 안내 후 로그인 페이지.
        if (err?.code === 'phone_already_registered') {
          const existingProvider = err?.response?.headers?.['x-existing-provider'];
          alert(existingProvider
            ? t('errors.phone_already_registered_with_provider', { provider: existingProvider })
            : t('errors.phone_already_registered'));
        } else {
          alert(translateApiError(err, t, 'auth.alert_naver_login_failed'));
        }
        navigate('/login', { replace: true });
      }
    };
    run();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-mono-600">{t('common.loading')}</p>
    </div>
  );
}
